// Input-time URL normalization for the `UrlInput` primitive. `stripUrlProtocol`
// renders the stored value without its scheme (nicer preview); the `normalize*`
// helpers re-add a scheme as the user types. Submit-time normalization (host
// lowercasing, empty -> null) is a separate concern owned by each form's schema.

export const normalizeUrl = (value: string): string => {
  const trimmed = value.trim();
  if (!trimmed) return "";
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed.replace(/^\/+/, "")}`;
};

export const normalizeSocialUrlInput = (value: string): string => {
  const trimmed = value.trim();
  if (!trimmed) return "";
  const withoutProtocol = trimmed.replace(/^https?:\/\//i, "").replace(/^\/+/, "");
  return `https://${withoutProtocol}`;
};

export const stripUrlProtocol = (value: string): string => value.replace(/^https?:\/\//i, "");
